import { FileOutlinedOutlineIcon } from '@carboncopyco/icons';
import type { Workspace } from '@carboncopyco/types';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import { WorkspaceAvatar } from '../WorkspaceAvatar';

interface WorkspaceItemProps {
  workspace: Pick<Workspace, 'workspaceName' | 'color' | 'workspaceType'>;
  disabled?: boolean;
}

export const WorkspaceItem = ({ workspace, disabled }: WorkspaceItemProps) => {
  return (
    <span className="flex items-center gap-1.5 w-full">
      {workspace.workspaceType === 'playground' ? (
        <FileOutlinedOutlineIcon color={ColorHex.natural} />
      ) : (
        <WorkspaceAvatar
          size="small"
          workspace={workspace}
        />
      )}
      <TextBase
        ellipsis
        label={workspace.workspaceName}
        color={disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'}
      />
    </span>
  );
};
